import { Autocomplete, TextField, Typography, useTheme } from "@mui/material";
import { PropsWithChildren, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";



export type FormComboBoxProps = {
    rules?: any;
    size?: "small" | "medium" | undefined;
    boldOnDirty?: boolean;
    onChanging?: (toValue: string | number, fromValue: string | number) => Promise<boolean>;
    onChange?: (newValue: string | number) => void;
    options: string[]
} & FormFieldPropsBase;

export default function FormComboBox({
    name,
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    rules,
    children,
    sx,
    disabled,
    size,
    boldOnDirty,
    onChanging,
    onChange,
    options,
    showID
}: PropsWithChildren<FormComboBoxProps>): JSX.Element {
    const { control } = useFormContext();
    const theme = useTheme();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { ref, name, value, onChange: onFieldChange, onBlur },
                    fieldState: { invalid, isTouched, isDirty, error },
                    formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (


                    <>


                    <Autocomplete
                        freeSolo
                        id={id}
                        disableClearable
                        options={options}
                        getOptionLabel={(option) => {
                            return typeof option === 'number' ? options[option] : option
                        }}

                        data-testid={testId}
                        aria-label={ariaLabel ?? undefined}
                        sx={{
                            marginTop: 0,
                            ...sx
                        }}



                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="filled"
                                label={label ?? undefined}
                                error={invalid}
                                helperText={invalid ? error.message : helperText}
                                inputRef={ref}
                                slotProps={{
                                    ...params.slotProps,
                                    input: {
                                        ...params.slotProps.input,
                                        readOnly: readOnly,
                                        sx: {
                                            fontWeight: boldOnDirty && isDirty ? 700 : 400
                                        },
                                        endAdornment: showID ? <Typography sx={{
                                            color: theme.palette.primary.light,
                                            position: 'absolute', 
                                            fontSize: 'small',
                                            top: '6px', 
                                            right: '12px'
                                        }}>{`[${id}]`}
                                        </Typography> : null


                                    },
                                    inputLabel: {
                                        shrink: true
                                    }
                                }}    
                                onChange={
                                    (e) => {
                                        const newValue = e.target.value;
                                        onFieldChange(newValue);
                                        onChange?.(newValue);
                                    }
                                }
                            />
                        )}


                        value={value}
                        disabled={disabled}
                        size={size}
                        onBlur={onBlur}
                        onChange={
                            async (e, newValue) => {
                                //if (!onChanging || await onChanging(newValue, value)) {
                                    onFieldChange(newValue);
                                    onChange?.(newValue);
                                //}
                            }
                        }
                    />




                </>






                )
            }
        />
    );
}